import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Foundations'

export const AddressManualEntryFieldsetStyled = styled.fieldset({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.sm,
  border: 'none',
  boxSizing: 'border-box',
  margin: '0 0 0.5rem',
  padding: 0,
})
